import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Discover.css';

const Discover = () => {
  const { t, i18n } = useTranslation(); // Hook para traducciones
  const [articles, setArticles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [articlesPerPage] = useState(6);
  const [selectedArticle, setSelectedArticle] = useState(null);

  useEffect(() => {
    const setArchivo = async ()=>{
      try {
        const fileName = t('articles');
        const articlesTest = await import(`./${fileName}`);
        setArticles(articlesTest.default);
      } catch (error) {
        console.error('Error al cargar el archivo de artículos:', error);
      }
    }

    setArchivo();
  }, [i18n.language]);

  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = articles.slice(indexOfFirstArticle, indexOfLastArticle);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(articles.length / articlesPerPage);

  const handleReadArticle = (article) => {
    setSelectedArticle(article);
  };

  const handleBackToList = () => {
    setSelectedArticle(null);
  };

  if (selectedArticle) {
    return (
      <div className="article-view-container">
        <div className="article-view">
          <div className="article-content">
              <button
                onClick={() => handleBackToList()}
                className="btn btn-link back-button">
                <i className="ph-arrow-circle-left back-icon"></i>  {t('returnDiscover')}
              </button>
            <h1>{selectedArticle.title}</h1>
            <p className='date'>{selectedArticle.date}</p>
            <div dangerouslySetInnerHTML={{ __html: selectedArticle.content }} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="discover content pt-0">
      <div className='footer-margin'>
      <div className="row">
        {currentArticles.map(article => (
          <div key={article.id} className="card">
            <div className="card-body">
              <div className="card-img-actions mb-3">
                <img className="card-img" src={article.image} alt={article.title} />
              </div>

              <h5 className="card-title pt-1 mb-1">
                <a href="#" onClick={() => handleReadArticle(article)} className="text-body">{article.title}</a>
              </h5>

              <ul className="list-inline list-inline-bullet text-muted mb-3">
                <li className="list-inline-item">{article.date}</li>
              </ul>

              <div className="card-description">
                {article.description}
              </div>
            </div>

            <div className="card-footer">
              <button
                onClick={() => handleReadArticle(article)}
                className="d-inline-flex align-items-center ms-auto btn btn-link">
                {t('read')} + <i className="ph-arrow-circle-right ms-2"></i>
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-center pt-3 mb-3">
        <ul className="pagination pagination-flat">
          <li className="page-item">
            <button href="#" className="page-link rounded-pill" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
              <i className="ph-arrow-left"></i>
            </button>
          </li>
          {[...Array(totalPages)].map((_, index) => (
            <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
              <button href="#" className="page-link rounded-pill" onClick={() => paginate(index + 1)}>
                {index + 1}
              </button>
            </li>
          ))}
          <li className="page-item">
            <button href="#" className="page-link rounded-pill" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
              <i className="ph-arrow-right"></i>
            </button>
          </li>
        </ul>
      </div>
      </div>
    </div>
  );
};

export default Discover;